module.exports = __webpack_public_path__ + "img/w2.2a85b2d6.png";